import useValidateLogin from "./authentication/useValidateLogin";
import useValidateSignup from "./authentication/useValidateSignup";
import useNewPassword from "./authentication/useNewPassword";
import useRecoverPassword from "./authentication/useRecoverPassword";
import { usePagination } from "./usePagination";
import useCheckout from "./checkout/useCheckout";
import useValidateNewUser from "./authentication/useValidateNewUser";
import useValidateToken from "./authentication/useValidateToken";
import useFetchProducts from "./useFetchProducts";
import useChangePassword from "./account/useChangePassword";
import FetchAddresses from "./account/fetchAddresses";
import useAddAddress from "./account/useAddAddress";
import useEditUserInfo from "./account/useEditUserInfo";
import useFetchUser from "./account/useFetchUser";
import useAvatarUpload from "./account/useAvatarUpload";
import useEditAddress from "./account/useEditAddress";
import useShopWithFriends from "./groupcart/useShopWithFriends";
import useGroupCartProduct from "./groupcart/useGroupCartProduct";
import useAddToCart from "./cart/useAddToCart";
import useDeleteCartItem from "./cart/useDeleteCartItem";
import useProductQuantity from "./cart/useProductQuantity";
import useUpdateCartLocation from "./cart/useUpdateCartLocation";
import FetchAllGroupCarts from "./groupcart/fetchAllGroupCarts";
import useProduct from "./products/useProduct";
import useGuarantee from "./landingPage/useGuarantee";
import useFavourites from "./landingPage/useFavourites";
import useHandleSubscription from "./landingPage/useHandleSubscription";
import { useGetContentful, useHandleContactForm } from "./blog";

export {
	useValidateLogin,
	useValidateSignup,
	useRecoverPassword,
	usePagination,
	useNewPassword,
	useCheckout,
	useValidateNewUser,
	useValidateToken,
	useFetchProducts,
	useChangePassword,
	FetchAddresses,
	useAddAddress,
	useEditUserInfo,
	useFetchUser,
	useAvatarUpload,
	useEditAddress,
	useShopWithFriends,
	useGroupCartProduct,
	useProductQuantity,
	useDeleteCartItem,
	useAddToCart,
	useUpdateCartLocation,
	FetchAllGroupCarts,
	useProduct,
	useGuarantee,
	useFavourites,
	useHandleSubscription,
	useGetContentful,
	useHandleContactForm,
};
